export const MANIFEST_DATA = [
  {
    "id": "38x44-monitor-barn",
    "name": "Dobbins Branch Barn",
    "type": "cadwork-html",
    "href": "assets/Models/LC14 - 38x44 Monitor Barn/LC14 38x44 Monitor Barn V5.1.1.html",
    "description": "38x44 Monitor style barn.",
    "tag": "Barns",
    "price": "$79,999",
    "features": [
      "38x44 footprint",
      "Mortice & Tenon Construction",
      "Half Loft",
      "8x10 Plates",
      "8x8 Posts",
      "8x12 Ridge",
      "8x10 Rafters"
    ],
    "gallery": [
      "assets/Models/LC14 - 38x44 Monitor Barn/renders/LCTF Web Size 2025 ZF-105 (1).jpg",
      "assets/Models/LC14 - 38x44 Monitor Barn/renders/LCTF Web Size 2025 ZF-6.jpg",
      "assets/Models/LC14 - 38x44 Monitor Barn/renders/LCTF Web Size 2025 ZF-8.jpg",
      "assets/Models/LC14 - 38x44 Monitor Barn/renders/LCTF Web Size 2025 ZF-92 (1).jpg",
      "assets/Models/LC14 - 38x44 Monitor Barn/renders/LCTF Web Size 2025 ZF-98.jpg"
    ],
    "thumbnail": "assets/Models/LC14 - 38x44 Monitor Barn/Cover.webp",
    "originalPrice": "$118,999",
    "onSale": true
  },
  {
    "id": "old-natchez-trace",
    "name": "Old Natchez Studio",
    "type": "cadwork-html",
    "href": "assets/Models/LC19 - 22x66 Old Natchez Trace (Full Size)/LC19 Old Natchez Trace V5.1.1.html",
    "description": "The perfect blend of indoor and outdoor luxury space.",
    "tag": "Barns",
    "price": "$89,999",
    "features": [
      "True mortice and tenon construction",
      "10x10 Posts",
      "8x10 Plates",
      "22x32 Indoor Space",
      "22x34 Outdoor Space"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LC19 - 22x66 Old Natchez Trace (Full Size)/Cover.webp",
    "onSale": true,
    "originalPrice": "#102,999"
  },
  {
    "id": "lc19-1-old-natchez-decorative-element",
    "name": "Old Natchez Decorative Element",
    "type": "cadwork-html",
    "href": "assets/Models/LC19_1 - Old Natchez Decorative Element/LC19 Old Natchez Trace V5.1.1 - Decorative Element Only.html",
    "description": "Old Natchez Decorative Element with timber frame construction",
    "tag": "Other",
    "price": "coming soon",
    "features": [
      "Old footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LC19_1 - Old Natchez Decorative Element/Cover.webp"
  },
  {
    "id": "lc19-old-natchez-reduced",
    "name": "Natchez Whiskey Cabin",
    "type": "coming-soon",
    "href": "",
    "description": "This is the perfect escape after a long day.",
    "tag": "Other",
    "price": "75,999",
    "features": [
      "True Mortice & Tenon Construction",
      "22x32 Footprint",
      "10/12 Pitch",
      "High Ceilings",
      "Oversized Timbers"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LC19_R - Old Natchez Reduced/Cover.webp",
    "onSale": true,
    "originalPrice": "85,999"
  },
  {
    "id": "lctf-barn",
    "name": "Robinson Barn",
    "type": "cadwork-html",
    "href": "assets/Models/LC20 - 33x39 LCTF Barn/LC20 LCTF Barn.html",
    "description": "This versatile barn can be used as a living space, shop, animal barn, or all of the above!",
    "tag": "Barns",
    "price": "$89,999",
    "features": [
      "33x39 Footprint",
      "Full or Half Loft",
      "Three Large Bays",
      "Oversized Timbers"
    ],
    "gallery": [
      "assets/Models/LC20 - 33x39 LCTF Barn/renders/IMG_2971.webp"
    ],
    "thumbnail": "assets/Models/LC20 - 33x39 LCTF Barn/Cover.webp",
    "originalPrice": "$117,999",
    "onSale": true
  },
  {
    "id": "old-natchez-studio",
    "name": "Montpier Cabin",
    "type": "cadwork-html",
    "href": "assets/Models/LC22 - 21x24 Old Natchez Studio/LC22 Shed 24x21 V2.1.1.html",
    "description": "Completely enclose this space or build a small cabin with a porch!",
    "tag": "Other",
    "price": "$39,999",
    "features": [
      "24x21 Footprint",
      "True Mortice & Tenon Construction",
      "Oversized Timbers"
    ],
    "gallery": [
      "assets/Models/LC22 - 21x24 Old Natchez Studio/renders/LC22 Shed 24x21 V2.2.1 - closed 3 (1).webp"
    ],
    "thumbnail": "assets/Models/LC22 - 21x24 Old Natchez Studio/Cover.webp",
    "originalPrice": "$54,999",
    "onSale": true
  },
  {
    "id": "lctf-pf1",
    "name": "14x18 Hammer Beam Pavilion",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF1 - Hammer Beam Pavilion 14x18 V1.1.1/LCTF PF1 Hammer Beam Pavilion 14x18 V1.1.3.html",
    "description": "Compact but incredibly beautiful design, perfect for elevating your backyard experience.",
    "tag": "Pavilion/Pergola",
    "price": "$29,999",
    "features": [
      "14x18 Footprint",
      "Old World Design",
      "True Mortice & Tenon",
      "Perfect Hosting Space"
    ],
    "gallery": [
      "assets/Models/LCTF PF1 - Hammer Beam Pavilion 14x18 V1.1.1/renders/IMG_2972.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF1 - Hammer Beam Pavilion 14x18 V1.1.1/Cover.webp",
    "originalPrice": "$39,399",
    "onSale": true
  },
  {
    "id": "lctf-pf10",
    "name": "Scissor Entryway",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF10 - Scissor Truss Entryway/LCTF PF10 Scissor Truss Entryway V1.1.1.html",
    "description": "Upgrade your entryway!",
    "tag": "Entries",
    "price": "$16,999",
    "features": [
      "Scissor Style",
      "True Mortice & Tenon Construction",
      "Upgrade your Entry"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF10 - Scissor Truss Entryway/Cover.webp",
    "originalPrice": "$21,599",
    "onSale": true
  },
  {
    "id": "lctf-pf11",
    "name": "Curved Truss Entryway",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF11 - Curved Truss Entryway/LCTF PF11 Curved Truss Entryway V1.1.1.html",
    "description": "Curved Truss Entryway with timber frame construction.",
    "tag": "Entries",
    "price": "$13,999",
    "features": [
      "Curved Old World Design",
      "True Mortice & Tenon Construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF11 - Curved Truss Entryway/renders/Scene 16.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF11 - Curved Truss Entryway/Cover.webp",
    "originalPrice": "$19,999",
    "onSale": true
  },
  {
    "id": "lctf-pf12",
    "name": "King Post Entryway",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF12 - Simple Entryway/LCTF PF12 Simple Entryway.html",
    "description": "King Post Entryway with timber frame construction.",
    "tag": "Entries",
    "price": "$12,999",
    "features": [
      "Classic Truss Design",
      "Mortice & Tenon Construction",
      "Oversized Timbers"
    ],
    "gallery": [
      "assets/Models/LCTF PF12 - Simple Entryway/renders/Scene 1_1.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF12 - Simple Entryway/Cover.webp",
    "originalPrice": "$16,999",
    "onSale": true
  },
  {
    "id": "lctf-pf13",
    "name": "12x16 Classic Pergola",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF13 - Simple Pergola 12x16/LCTF PF13 Simple Pergola 12x16.html",
    "description": "12x16 Pergola with timber frame construction.",
    "tag": "Pavilion/Pergola",
    "price": "$15,999",
    "features": [
      "12x16 Footprint",
      "Mortice & Tenon Construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF13 - Simple Pergola 12x16/Cover.webp",
    "originalPrice": "$19,999",
    "onSale": true
  },
  {
    "id": "lctf-pf14",
    "name": "12x18 Pergola",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF14 - Simple Pergola 12x18 V1.1.1/LCTF PF14 Simple Pergola 12x18 V1.1.1.html",
    "description": "12x18 Pergola with timber frame construction",
    "tag": "Pavilion/Pergola",
    "price": "$19,999",
    "features": [
      "12x18 footprint",
      "Timber frame construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF14 - Simple Pergola 12x18 V1.1.1/renders/IMG_2975.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF14 - Simple Pergola 12x18 V1.1.1/Cover.webp",
    "originalPrice": "$29,999",
    "onSale": true
  },
  {
    "id": "lctf-pf15",
    "name": "12x16 Pergola",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF15 - Slanted Pergola 12x16 V1.1.1/LCTF PF15 Slanted Pergola 12x16 V1.1.1.html",
    "description": "12x16 Pergola with timber frame construction",
    "tag": "Pavilion/Pergola",
    "price": "$18,999",
    "features": [
      "12x16 footprint",
      "Timber frame construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF15 - Slanted Pergola 12x16 V1.1.1/renders/IMG_2977.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF15 - Slanted Pergola 12x16 V1.1.1/Cover.webp",
    "originalPrice": "$24,999",
    "onSale": true
  },
  {
    "id": "lctf-pf16",
    "name": "10x16 Simple Pergola",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF16 - Simple Pergola 10x16 V1.1.1/LCTF PF16 Simple Pergola 10x16 V1.1.1.html",
    "description": "10x16 Simple Pergola with timber frame construction",
    "tag": "Pavilion/Pergola",
    "price": "$21,999",
    "features": [
      "10x16 footprint",
      "Timber frame construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF16 - Simple Pergola 10x16 V1.1.1/renders/IMG_2974.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF16 - Simple Pergola 10x16 V1.1.1/Cover.webp",
    "originalPrice": "$27,999",
    "onSale": true
  },
  {
    "id": "lctf-pf17",
    "name": "Nashville Festival Pavilion",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF17 - Simple Pavilion 16x24 3.1.1/LCTF PF17 Simple Pavilion 16x24 3.2.1.html",
    "description": "16x24 King Post Pavilion with timber frame construction.",
    "tag": "Pavilion/Pergola",
    "price": "$33,999",
    "originalPrice": "$36,999",
    "onSale": true,
    "speciesPricing": [
      {
        "species": "Eastern White Pine",
        "price": "$33,999",
        "originalPrice": "$36,999",
        "default": true
      },
      {
        "species": "Douglas Fir",
        "price": "$51,629",
        "originalPrice": "$54,629"
      },
      {
        "species": "White Oak",
        "price": "$52,126",
        "originalPrice": "$55,126"
      }
    ],
    "features": [
      "16x24 Footprint",
      "Mortice & Tenon Construction",
      "Versatile Pavilion, Chapel, or Event Venue"
    ],
    "gallery": [
      "assets/Models/LCTF PF17 - Simple Pavilion 16x24 3.1.1/renders/IMG_2976.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF17 - Simple Pavilion 16x24 3.1.1/Cover.webp"
  },
  {
    "id": "lctf-pf18",
    "name": "14x22 Pergola",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF18 - Simple Pergola 14x22 V1.1.1/LCTF PF18 Simple Pergola 14x22 V1.1.1.html",
    "description": "14x22 Pergola with timber frame construction.",
    "tag": "Pavilion/Pergola",
    "price": "$23,999",
    "features": [
      "14x22 Footprint",
      "Mortice & Tenon Construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF18 - Simple Pergola 14x22 V1.1.1/Cover.webp",
    "originalPrice": "$31,199",
    "onSale": true
  },
  {
    "id": "lctf-pf19",
    "name": "14x22 Modified Pergola",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF19 - Simple 14x22 Modified/LCTF PF19 Simple Pergola 14x22 Modified V1.2.1.html",
    "description": "14x22 Modified Pergola with timber frame construction",
    "tag": "Pavilion/Pergola",
    "price": "$23,999",
    "features": [
      "14x22 footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF19 - Simple 14x22 Modified/Cover.webp"
  },
  {
    "id": "lctf-pf2",
    "name": "10x16 Curved Truss Pavilion",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF2 - Simple Curve Pavilion 10x16 V1.1.1/LCTF PF2 Simple Curve Pavilion 10x16 V1.1.1.html",
    "description": "10x16 Simple Curve Pavilion with timber frame construction.",
    "tag": "Pavilion/Pergola",
    "price": "$20,199",
    "features": [
      "10x16 Footprint",
      "Mortice & Tenon Construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF2 - Simple Curve Pavilion 10x16 V1.1.1/renders/IMG_2973.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF2 - Simple Curve Pavilion 10x16 V1.1.1/Cover.webp",
    "originalPrice": "$31,299",
    "onSale": true
  },
  {
    "id": "lctf-pf3",
    "name": "14x20 Cruck Pavilion",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF3 - Cruck Pavilion 14x20 V1.2.1/LCTF PF3 Cruck Pavilion 14x20 V1.2.1.html",
    "description": "14x20 Cruck Pavilion with timber frame construction",
    "tag": "Pavilion/Pergola",
    "price": "$28,999",
    "features": [
      "14x20 footprint",
      "Timber frame construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF3 - Cruck Pavilion 14x20 V1.2.1/renders/IMG_2979.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF3 - Cruck Pavilion 14x20 V1.2.1/Cover.webp",
    "originalPrice": "$44,999",
    "onSale": true
  },
  {
    "id": "lctf-pf4",
    "name": "16x18 Scissor Truss Pavilion",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF4 - Scissor Truss Pavilion 16x18 V1.2.1/LCTF PF4 Scissor Truss Pavilion 16x18 V1.2.1.html",
    "description": "16x18 Scissor Truss Pavilion with timber frame construction",
    "tag": "Pavilion/Pergola",
    "price": "$26,999",
    "features": [
      "16x18 footprint",
      "Timber frame construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF4 - Scissor Truss Pavilion 16x18 V1.2.1/renders/IMG_2978.webp"
    ],
    "thumbnail": "assets/Models/LCTF PF4 - Scissor Truss Pavilion 16x18 V1.2.1/Cover.webp",
    "originalPrice": "$40,999",
    "onSale": true
  },
  {
    "id": "lctf-pf5",
    "name": "Simple Corbel",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF5 - Simple Corbel/LCTF PF5 Simple Corbel V1.1.1.html",
    "description": "Simple Corbel with timber frame construction",
    "tag": "Decorative",
    "price": "coming soon",
    "features": [
      "Simple footprint",
      "Timber frame construction"
    ],
    "gallery": [
      "assets/Models/LCTF PF5 - Simple Corbel/renders/Screenshot 2025-10-24 124557.webp",
      "assets/Models/LCTF PF5 - Simple Corbel/renders/Screenshot 2025-10-24 124636.webp",
      "assets/Models/LCTF PF5 - Simple Corbel/renders/Screenshot 2025-10-24 124736.webp",
      "assets/Models/LCTF PF5 - Simple Corbel/renders/Screenshot 2025-10-24 124736.png"
    ],
    "thumbnail": "assets/Models/LCTF PF5 - Simple Corbel/Cover.webp",
    "hidden": true
  },
  {
    "id": "lctf-pf6",
    "name": "Simple Corbel",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF6 - Simple Corbel/LCTF PF6 Simple Corbel V1.1.1.html",
    "description": "Simple Corbel with timber frame construction",
    "tag": "Decorative",
    "price": "coming soon",
    "features": [
      "Simple footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF6 - Simple Corbel/Cover.webp",
    "hidden": true
  },
  {
    "id": "lctf-pf7",
    "name": "Standalone Corbel",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF7 - One Piece Corbel/LCTF PF7 One Piece Corbel V1.1.1.html",
    "description": "Standalone Corbel with timber frame construction",
    "tag": "Decorative",
    "price": "coming soon",
    "features": [
      "Standalone footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF7 - One Piece Corbel/Cover.webp",
    "hidden": true
  },
  {
    "id": "lctf-pf8",
    "name": "Angled Corbel",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF8 - Angled Corbel/LCTF PF8 Angled Corbel V1.1.1.html",
    "description": "Angled Corbel with timber frame construction",
    "tag": "Decorative",
    "price": "coming soon",
    "features": [
      "Angled footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF8 - Angled Corbel/Cover.webp",
    "hidden": true
  },
  {
    "id": "lctf-pf9",
    "name": "Simple Entryway",
    "type": "cadwork-html",
    "href": "assets/Models/LCTF PF9 - Simple Entryway/LCTF PF9 Simple Entryway V1.1.1.html",
    "description": "Simple Entryway with timber frame construction",
    "tag": "Entries",
    "price": "$14,460",
    "features": [
      "Simple footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LCTF PF9 - Simple Entryway/Cover.webp",
    "originalPrice": "$18,899",
    "onSale": true
  },
  {
    "id": "lone-oak-barn",
    "name": "Witherspoon Equestrian Barn",
    "type": "cadwork-html",
    "href": "assets/Models/LC_101 - 48x60 Equestrian Barn/Lone Oak Barn.html",
    "description": "48x60 Equestrian Barn with timber frame construction.",
    "tag": "Barns",
    "price": "$115,999",
    "features": [
      "48x60 Footprint",
      "Mortice & Tenon Construction",
      "Divide up for Stalls, or keep open for events"
    ],
    "gallery": [
      "assets/Models/LC_101 - 48x60 Equestrian Barn/renders/Loan Oak - closed (1).webp"
    ],
    "thumbnail": "assets/Models/LC_101 - 48x60 Equestrian Barn/Cover.webp",
    "originalPrice": "$149,999",
    "onSale": true
  },
  {
    "id": "notch-barn",
    "name": "36x52 Dairy Barn",
    "type": "cadwork-html",
    "href": "assets/Models/LC_102 - 36x52 Dairy Barn/Notch Barn.html",
    "description": "36x52 Dairy Barn with timber frame construction",
    "tag": "Barns",
    "price": "$79,499",
    "features": [
      "36x52 Footprint",
      "Half Loft",
      "Mortice & Tenon Construction"
    ],
    "gallery": [
      "assets/Models/LC_102 - 36x52 Dairy Barn/renders/Notch Barn (1).webp"
    ],
    "thumbnail": "assets/Models/LC_102 - 36x52 Dairy Barn/Cover.webp",
    "originalPrice": "$96,999",
    "onSale": true
  },
  {
    "id": "24x30-cottage",
    "name": "24x30 Cottage",
    "type": "cadwork-html",
    "href": "assets/Models/LC_103 - 24x30 Cottage/24x30 Cottage V1.1.1.html",
    "description": "24x30 Cottage with timber frame construction",
    "tag": "Other",
    "price": "$71,399",
    "hidden": true,
    "features": [
      "24x30 footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LC_103 - 24x30 Cottage/Cover.webp"
  },
  {
    "id": "50-covered-bridge",
    "name": "50' Covered Bridge",
    "type": "coming-soon",
    "href": "",
    "description": "50' Covered Bridge with timber frame construction",
    "tag": "Other",
    "price": "coming soon",
    "features": [
      "50' footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LC_104 - 50' Covered Bridge/Cover.webp"
  },
  {
    "id": "bee-tree-hill",
    "name": "Bee Tree Hill Barn",
    "type": "cadwork-html",
    "href": "assets/Models/LC_105 - Bee Tree Hill/Bee Tree Hill 54x30 Barn V1.1.1.html",
    "description": "Incredibly versatile space - use for a large workshop, animal stalls, living space, or event venue!",
    "tag": "Barns",
    "price": "$79,999",
    "features": [
      "30x50 Footprint",
      "Mortice & Tenon Construction",
      "4/12 Pitch Monitor Style Roof"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LC_105 - Bee Tree Hill/Cover.webp",
    "originalPrice": "$96,599",
    "onSale": true
  },
  {
    "id": "20x36-cruck-pavilion",
    "name": "20x36 Cruck Pavilion",
    "type": "cadwork-html",
    "href": "assets/Models/LC_106 - 20x36 Cruck Pavilion/Cruck Pavilion 20x36 V1.1.1.html",
    "description": "20x36 Cruck Pavilion with timber frame construction",
    "tag": "Pavilion/Pergola",
    "price": "$71,999",
    "hidden": true,
    "features": [
      "20x36 footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "thumbnail": "assets/Models/LC_106 - 20x36 Cruck Pavilion/Cover.webp"
  },
  {
    "id": "36x42-monitor-barn",
    "name": "36x42 Monitor Barn",
    "type": "cadwork-html",
    "href": "assets/Models/LC_107 - 36x42 Monitor Barn Web Viewer/LC14 36x42 Monitor Barn Web Viewer.html",
    "description": "36x42 Monitor Barn with timber frame construction",
    "tag": "Barns",
    "price": "$78,999",
    "features": [
      "36x42 footprint",
      "Timber frame construction"
    ],
    "gallery": [],
    "originalPrice": "$106,399",
    "onSale": true
  }
];
